import React, { useState, useEffect } from "react";
import { memo } from "react";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import shipmentStylez from "./Shipment.module.css";
import ShipmentTable from "./ShipmentTable/ShipmentTable";
import axiosInstance from "../../Configuration/axiosInstance";
import SuccessDialogue from "../../Components/Shared/SuccessDialog/SuccessDialog";
import LoadingSpinner from "../../Components/Shared/Loader/Loader";
import ShipmentCard from "../../Components/Shipments/ShipmentCard/ShipmentCard";
const Shipments = ({
  searchParams,
  setSearchParams,
  completed,
  tableHeaders,
  header,
}) => {
  const [date, setDate] = useState();
  const [formData, setFormData] = useState({
    blNumber: "",
    Vessel: "",
    containerNumber: "",
    sealNumber: "",
    etd: "",
    eta: "",
    unloadDate: "",
  });
  const [data, setData] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [product, setProduct] = useState();
  const [stock, setStock] = useState(0);
  const [productArr, setProductArr] = useState([]);
  const [productModal, setProductModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [prodOptions, setProdOptions] = useState();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [count, setCount] = useState();
  const [refresh, setRefresh] = useState(false);
  const [msg, setMsg] = useState();
  const [dialogBox, setDialogBox] = useState(false);
  const [warehouses, setWareHouses] = useState();
  const [loading, setIsLoading] = useState(true);
  const [clearFilters, setClearFilters] = useState(false);

  const handleInputChange = (e) => {
    setSearchParams({
      ...searchParams,
      [e.target.name]: e.target.value,
    });
  };

  /**
   * Add the shipment to an existing product inventory.
   * Match the id from the MongoDatabase to edit and view the changes in the database
   * On click change the shipment status to completed
   */
  /**
   * Pagination works by sending filter and page request to the backend
   * The backend then validates if the order has been sent or not.
   *
   */
  useEffect(() => {
    setIsLoading(true);
    //Loag
    axiosInstance.get(`products/allproducts`).then((data) => {
      setProdOptions(data.data.data);
    });
    axiosInstance
      .get(`shipments?page=${page}&limit=${pageSize}}`, {
        params: searchParams,
      })
      .then((data) => {
        setData(data.data.data);
        setCount(data.data.count);
        setIsLoading(false);
      });

    axiosInstance.get(`warehouse`).then((res) => {
      console.log(res.data.data);
      setWareHouses(res.data.data);
    });
  }, [page, refresh]);

  const toggle = () => {
    setIsOpen((prevState) => !prevState);
  };

  const productAddOn = (newItem) => {
    if (productArr?.find((item) => item?.product === newItem?.product)) {
      console.log("Does it trigger for undefined");
      setProductArr(() =>
        productArr.map((item) =>
          item.product === newItem.product
            ? {
                ...item,
                quantity: Number(item.quantity) + Number(newItem.quantity),
              }
            : item
        )
      );
    } else {
      setProductArr((preValue) => [...preValue, newItem]);
    }
  };

  const postData = (i) => {
    console.log(i.product);
  };

  const resetForm = () => {
    setFormData({
      blNumber: "",
      Vessel: "",
      containerNumber: "",
      sealNumber: "",
      etd: "",
      eta: "",
      unloadDate: "",
    });
    setProduct(null);
    setProductArr([]);
  };

  const psData = (event, shipmentData = null) => {
    setDialogBox(true);
    setMsg("Creating shipment with multiple containers. Please wait...");
    event.preventDefault();

    // Use either provided shipmentData or legacy format
    const dataToSubmit = shipmentData || { items: productArr, ...formData };

    // Validate shipment data
    if (shipmentData) {
      // New format validation
      if (
        !formData.blNumber ||
        !formData.eta ||
        !formData.unloadDate ||
        !formData.etd ||
        !shipmentData.containers ||
        shipmentData.containers.length === 0
      ) {
        setMsg(
          "Please fill in all required fields and add at least one container with products ❗"
        );
        setDialogBox(true);
        setTimeout(() => {
          setDialogBox(false);
        }, 5000);
        return;
      }
    } else {
      // Legacy format validation
      if (
        !formData.blNumber ||
        !formData.Vessel ||
        !formData.containerNumber ||
        !formData.sealNumber ||
        !formData.eta ||
        !formData.unloadDate ||
        !formData.etd ||
        productArr.length === 0
      ) {
        setMsg("Please fill in all required fields ❗");
        setDialogBox(true);
        setTimeout(() => {
          setDialogBox(false);
        }, 5000);
        return;
      }
    }

    axiosInstance
      .post(`shipments`, dataToSubmit)
      .then((res) => {
        setMsg(res.data.message || "Shipment created successfully ✅");
      })
      .catch((error) => {
        console.error("Error creating shipment:", error);
        setMsg("Error creating shipment. Please try again.");
      });

    setTimeout(() => {
      setDialogBox(false);
      setMsg();
      setProductArr([]);
      resetForm();
      setRefresh(!refresh);
    }, 3000);
  };

  const handleNext = () => {
    setPage((preValue) => preValue + 1);
  };
  const handlePrevious = () => {
    setPage((preValue) => preValue - 1);
  };
  const deleteStock = (i) => {
    console.log("deleteStock", i);
    axiosInstance.delete(`shipments/${i}`).then((res) => {
      console.log(res.data);
    });
    setRefresh(!refresh);
    //
  };
  const handleSearch = () => {
    setClearFilters(true);
    setRefresh((prevValue) => !prevValue);
  };

  const handleRemoveFilter = (filterName) => {
    setClearFilters(false);

    // Reset the value for the specified filter in searchParams
    setSearchParams((prevSearchParams) => ({
      ...prevSearchParams,
      [filterName]: "",
    }));
    setRefresh((prevValue) => !prevValue);
  };

  return (
    <div>
      <h2>{header}</h2>
      <SuccessDialogue show={dialogBox} msg={msg} />

      <button
        type="button"
        onClick={toggle}
        className={shipmentStylez.toggleButton}
      >
        {isOpen ? (
          <div className={shipmentStylez.toggleDiv}>
            Hide
            <FaChevronUp className={shipmentStylez.toggleIcons} />
          </div>
        ) : (
          <div className={shipmentStylez.toggleDiv}>
            Add a new Shipment
            <FaChevronDown className={shipmentStylez.toggleIcons} />
          </div>
        )}
      </button>
      {isOpen ? null : (
        <div className={shipmentStylez.searchStrip}>
          <label>BL Number:</label>
          <input
            type="text"
            name="blNumber"
            value={searchParams.blNumber}
            onChange={handleInputChange}
          />

          <button className="searchBtn" onClick={handleSearch}>
            Search
          </button>
          {clearFilters && (
            <span
              className="searchSpan"
              style={{ marginRight: "15px", marginLeft: "5px" }}
            >
              {searchParams.blNumber}{" "}
              <button
                className="spanBtn"
                onClick={() => handleRemoveFilter("blNumber")}
              >
                {" "}
                &times;
              </button>
            </span>
          )}
        </div>
      )}
      <div className={isOpen ? shipmentStylez.collapse : shipmentStylez.hide}>
        <ShipmentCard
          data={{
            stock,
            product,
            setProduct,
            productArr,
            setProductArr,
            setStock,
            psData,
            productAddOn,
            prodOptions,
            formData,
            setFormData,
          }}
        />
      </div>
      {/* <div className={shipmentStylez.filterBanner}>
        <div className={shipmentStylez.filterMenu}>
          <span>Show only:</span>

          <div className={shipmentStylez.options}>
            <button
              className={[shipmentStylez.btns, shipmentStylez.editBtn].join(
                ' '
              )}
            >
              All
            </button>
            <button
              className={`${shipmentStylez.btns} ${shipmentStylez.confirmedBtn} `}
            >
              Confirmed
            </button>
            <button
              className={`${shipmentStylez.btns} ${shipmentStylez.pendingBtn} `}
            >
          
              Pending
            </button>
          </div>
        </div>
      </div> */}
      {count === 0 ? (
        <div>No More Shipments Found</div>
      ) : (
        <div>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <ShipmentTable
              completed={completed}
              route="shipments"
              data={data}
              tableHeaders={tableHeaders}
              postData={postData}
              setProductModal={setProductModal}
              setAddModal={setAddModal}
              productModal={productModal}
              addModal={addModal}
              deleteStock={deleteStock}
              setRefresh={setRefresh}
              refresh={refresh}
              warehouses={warehouses}
            />
          )}
        </div>
      )}

      <div className={shipmentStylez.pagination}>
        <button
          disabled={page === 1}
          onClick={handlePrevious}
          className={shipmentStylez.pageButton}
        >
          Previous
        </button>
        <span className={shipmentStylez.pages}>
          Page -<span className={shipmentStylez.pageNumber}>{page} </span>
        </span>
        <button
          disabled={count < pageSize}
          onClick={handleNext}
          className={shipmentStylez.pageButton}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default memo(Shipments);
